<template>
  <div>
    <h1 :class="headingClasses">
      <!-- If collection is selected -->
      <span v-if="selectedCollection.option" class="font-medium">
        {{ headingText }}
        <div
          v-if="!searchTerm && selectedCollectionHeadings"
          class="font-light"
        >
          {{ selectedCollectionHeadings.subheading }}
        </div>
        <span v-if="searchTerm">
          / {{ preSearchTerm }} for
          <div class="font-light">'{{ searchTerm }}'</div>
        </span>
      </span>

      <!-- If search term is entered but no collection selected -->
      <span v-if="searchTerm && !selectedCollection.option" class="font-medium"
        >{{ preSearchTerm }} for
        <div class="font-light">'{{ searchTerm }}'</div></span
      >

      <!-- No search term or collection selected -->
      <span v-if="!selectedCollection.option && !searchTerm" class="font-medium"
        >{{ page.title
        }}<span class="font-light"><br />{{ page.subheading }}</span></span
      >
    </h1>

    <!-- Static Description -->
    <div v-if="this.staticDescription" class="header-e1 font-light pb-8">
      {{ page.description }}
    </div>

    <!-- Collection description -->
    <div
      v-if="shouldShowCollectionDescription"
      class="header-e1 font-light pb-8"
    >
      {{ selectedCollectionHeadings.description }}
    </div>
  </div>
</template>

<script>
import { eventBus } from '../shared/event-bus';

export default {
  name: 'PageHeading',
  props: [
    'selectedCollection',
    'searchTerm',
    'resultsCount',
    'error',
    'categories',
    'page',
    'staticDescription',
  ],
  data() {
    return {
      selectedCollectionHeadings: {},
    };
  },
  watch: {
    selectedCollection() {
      this.mapCollectionDescription();
    },
  },
  mounted() {
    if (this.categories) this.mapCollectionDescription();
  },
  computed: {
    headingClasses() {
      return [
        'header-d1 md:h3 lg:h2 font-light lg:pb-10 md:pb-10 pb-6 pt-10',
        {
          'pb-6':
            this.selectedCollectionHeadings &&
            this.selectedCollectionHeadings.description,
        },
      ];
    },
    headingText() {
      return (
        this.selectedCollection.option.charAt(0).toUpperCase() +
        this.selectedCollection.option.slice(1)
      );
    },
    preSearchTerm() {
      if (this.error) {
        return 'Error searching';
      }

      return this.resultsCount == 0
        ? 'No Result'
        : `${this.resultsCount} Results`;
    },
    shouldShowCollectionDescription() {
      return (
        !this.searchTerm &&
        this.selectedCollection.option &&
        this.selectedCollectionHeadings &&
        this.selectedCollectionHeadings.description
      );
    },
  },
  methods: {
    mapCollectionDescription() {
      const selectedCollectionHeadings = JSON.parse(this.categories).find(
        collection => {
          return (
            collection.title.toLowerCase() ==
            this.selectedCollection.option.toLowerCase()
          );
        }
      );
      this.selectedCollectionHeadings = selectedCollectionHeadings;
    },
  },
};
</script>
